// สัญญาณ "โอกาสทางธุรกิจถูกแก้แล้ว" ข้ามหน้าต่าง/แท็บของเบราว์เซอร์เดียวกัน — services/marketing ไม่มี
// Socket.IO (ต่างจาก backend/ หลัก) ให้หน้าที่แสดงข้อมูลค้างอยู่ (เช่น OpportunityCalendarModal) รู้ตัว
// แล้วโหลดใหม่เองโดยไม่ต้อง refresh — ยิงจาก action เขียนข้อมูลใน MarketingAction.js หลังสำเร็จเท่านั้น
// BroadcastChannel ส่งถึงทุก instance ชื่อเดียวกันยกเว้นตัวที่ส่งเอง (รวมถึงในหน้าเดียวกัน) เลยสร้าง
// instance ใหม่ทุกครั้งที่ส่ง ครอบคลุมทั้ง popup ในหน้า, หน้าต่าง pop-out (/marketing-popup/:id) และแท็บอื่น
// ไม่ครอบคลุมการแก้จากเครื่อง/ผู้ใช้อื่น (ต้องมี socket ฝั่ง services/marketing)
const CHANNEL_NAME = 'marketing-opportunity-changed';

export function notifyOpportunityChanged() {
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage({ at: Date.now() });
    channel.close();
  } catch (e) {
    // เบราว์เซอร์ไม่รองรับ BroadcastChannel — ข้ามไป (หน้าต่างอื่นแค่ไม่อัปเดตเอง ต้อง refresh เหมือนเดิม)
  }
}

// คืนฟังก์ชันยกเลิกการฟัง
export function subscribeOpportunityChanged(callback) {
  let channel;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
  } catch (e) {
    return () => {};
  }
  channel.onmessage = () => callback();
  return () => channel.close();
}
